
				var addMethods = require("../../node_modules/workerize-loader/dist/rpc-wrapper.js")
				var methods = ["makePDF"]
				module.exports = function() {
					var w = new Worker(__webpack_public_path__ + "84e1e49ce43e3a8a60e1.worker.js", { name: "[hash].worker.js" })
					addMethods(w, methods)
					
					return w
				}
			